import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";


const LookLayoutHeader = () => {

  // const {intl} = props;

  // const printButtonClick = () => {
  //
  // }

  return (
    <header className="ll-header">
      <div className="ll-header__left">
        <h1 className="ll-title">
          <FormattedMessage id="look.layout.header.title"/>
        </h1>
        <h2 className="ll-sub-title">
          <FormattedMessage id="look.layout.header.subTitle"/>
        </h2>
      </div>
      <div className="ll-header__right">

      </div>
    </header>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookLayoutHeader)
)
